import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const useSharedStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    container: (props) => ({
      minWidth: 120,
      minHeight: 200,
      height: 'auto',
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
    }),
    mainContainer: {
      backgroundColor: '#fff',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexGrow: 1,
    },
  })
);
